import { render, staticRenderFns } from "./FeedbackDialog.vue?vue&type=template&id=66b8cd07&"
import script from "./FeedbackDialog.vue?vue&type=script&lang=js&"
export * from "./FeedbackDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports